import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { ChangeAllData, ChangeAnalysisData, ChangeListOperationMode, LogOut, changeHistoricCities, changeHistoricCity, changeHistoricEquipamentList, changeHistoricGraphData, changeHistoricListData, changeHistoricLoading, changeHistoricPagination, changeOnlyGraphsData, changeModal } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { HistoricRequest } from "./requests.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class HistoricServices {
    constructor() {
        this.Requests = new HistoricRequest();
        this.priorityItens = [
            // Geral
            'Horário',
            "Time",
            
            // Poços
            'Auto ajuste',
            'Fluoreto (ppm)',
            'Cloro livre (ppm)',
            'Cloro Livre Ponto 1 (ppm)',
            'Cloro Livre Ponto 2 (ppm)',
            'Turbidez tratada (NTU)',
            'Cor tratada (uC)',
            'Turbidez Decantada (NTU)',
            'Cor Decantada (uC)',
            'Turbidez Bruta (NTU)',
            'Cor bruta (uC)',
            'Turbidez filtrada 1 (NTU)', 'Turbidez filtrada 2 (NTU)', 'Turbidez filtrada 3 (NTU)', 'Turbidez filtrada 4 (NTU)',
            'Cor filtrada 1 (uC)', 'Cor filtrada 2 (uC)', 'Cor filtrada 3 (uC)', 'Cor filtrada 4 (uC)',
            'pH (pH)', 'pH 1 (pH)', 'pH 2 (pH)', 'pH 3 (pH)',
            'Temperatura (°C)', 'Temperatura 1 (°C)', 'Temperatura 2 (°C)', 'Temperatura 3 (°C)',
            'Vazão da bomba hipo (ml/min)',
            'Vazão da bomba ácido (ml/min)',
            'Vazão da bomba ortopolifosfato  (ml/min)',
            'Macro vazão (m³/h)', 'Macro vazão (L/s)', 'Macro diário (Litros)',
            'Nível (m)', 'Nível (%)', 'Pressão (bar)', 'Pressão (MCA)', 'Pressão 2 (bar)', 'Pressão 2 (MCA)',
            'Diferencial de pressão (bar)', 'Diferencial de pressão (MCA)',

            // Geral
            'Nível Reservatorio Elevado (%)', 
            'Nível Reservatorio Elevado (m)', 
            'Volume reservado Reservatorio Elevado (m³)',
            'Reservatorio Elevado Pressão (MCA)',
            'Volume total ocupado Reservatorio Elevado (%)',
            'Nível Reservatorio Semienterrado (%)',
            'Nível Reservatorio Semienterrado (m)',
            'Volume reservado Reservatorio Semienterrado (m³)',
            'Volume total ocupado Reservatorio Semienterrado (%)',
            'Reservatorio Semienterrado Pressão (MCA)',
            'Pressão Reservatorio Semienterrado (MCA)',

            // R8
            'Rede Areal Pressão (MCA)',
            'Rede Dunas Pressão (MCA)',
            'Rede Laranjal Pressão (MCA)',

            // R5
            'Entrada da Barragem Pressão (MCA)',
            'Saída da Duque Pressão (MCA)',
            'Saída de Aurora Pressão (MCA)',

            // Santa Barbara
            'Vazão Rede R7 (m³/h)',
            'Pressão Rede R7 (MCA)',
            'Vazão Rede R10 (m³/h)',
            'Pressão Rede R10 (MCA)',
            'Vazão Rede Centro (m³/h)',
            'Pressão Rede Centro (MCA)',
            'Vazão Rede Industrial (m³/h)',
            'Pressão Rede Industrial (MCA)',
        ];
        this.equipamentosList= [];
        this.equipamentsColors = [
            "#E69F00", // Laranja forte
            "#56B4E9", // Azul claro vibrante
            "#009E73", // Verde esmeralda
            "#0072B2", // Azul profundo
            "#FF0000", // Vermelho
            "#D55E00", // Laranja avermelhado
            "#CC79A7", // Magenta suave
            "#A6761D", // Marrom dourado
            "#1B9E77", // Verde escuro intenso
            "#D95F02", // Laranja queimado
            "#7570B3", // Roxo acinzentado
            "#E7298A", // Rosa vibrante
            "#66A61E", // Verde vivo
            "#E6AB02", // Mostarda
            "#A6761D", // Marrom dourado (repetido)
            "#666666", // Cinza médio
            "#8DA0CB", // Azul acinzentado
            "#FC8D62", // Laranja suave
            "#66C2A5", // Verde água
            "#E78AC3", // Rosa pastel
            "#FFD92F", // Amarelo vibrante

            "#FF4500", // Laranja escuro
            "#8B0000", // Vermelho escuro
            "#9400D3", // Roxo escuro
            "#9932CC", // Roxo médio
            "#8B008B", // Magenta escuro
            "#DC143C", // Carmesim
            "#B22222", // Tijolo
            "#A52A2A", // Marrom
            "#D2691E", // Chocolate
            "#8B4513", // Saddle Brown
            "#00CED1", // Turquesa escuro
            "#20B2AA", // Verde água escuro
            "#4682B4", // Azul aço
            "#5F9EA0", // Azul cádmio
            "#2F4F4F", // Cinza ardósia escuro
            "#191970", // Azul meia-noite
            "#4B0082"  // Índigo
        ];
    }

    // Função para buscar os equipamentos do usuário
    async getEquipamentos(){
        try {
            const equipamentosList = await this.Requests.getEquipamentosByUser();
            let List = [{id: '', nome: i18n.t("select.equipment") }];
            List.push(...equipamentosList.authorized_equipments.equipments);
            List.push(...equipamentosList.authorized_equipments.grouppings);
            this.equipamentosList = List;
            store.dispatch(changeHistoricEquipamentList(List));
            if(store.getState().HistoricReducer.city){
                this.filterEquipaments(store.getState().HistoricReducer.city);
            }
            return List;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Função para buscar os equipamentos do usuário
    async getPocos(){
        try {
            const equipamentosList = await this.Requests.getPocosByUser();
            let List = [{id: '', nome: i18n.t("select.equipment") }];
            List.push(...equipamentosList.authorized_pocos);
            this.equipamentosList = List;
            store.dispatch(changeHistoricEquipamentList(List));
            if(store.getState().HistoricReducer.city){
                this.filterEquipaments(store.getState().HistoricReducer.city);
            }
            return List;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Pega os dados gerais
    async getGeneralData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsGeneral(id, datainicio, datafim, page);
            this.formatTable(data[2]);
            store.dispatch(changeHistoricPagination(data[1]));
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
            return [];
        }
    }

    // Pega os dados gerais para os gráficos
    async getGraphData(id, datainicio, datafim){
        try {
            let data = await this.Requests.getmappingsGeneralGraph(id, datainicio, datafim);
            await this.generateGraphData(data);
            // store.dispatch(changeHistoricPagination(data[1]))
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
            return [];
        }
    }

    // Pega os dados de analises
    async getAnalysisData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsAnalysis(id, datainicio, datafim, page);
            let AL1 = await this.formatTableAnalysis(data[2]);
            let AL2 = await this.formatTableAnalysis(data[1]);
            let AL3 = await this.formatTableAnalysis(data[3]);
            let AL4 = await this.formatTableAnalysis(data[4]);
            let AL5 = await this.formatTableAnalysis(data[5]);
            let ph = await this.formatTableAnalysis(data[6]);

            let Cloro = this.formatDados(data[7]);
            let CorTratada = this.formatDados(data[8]);
            let Fluoreto = this.formatDados(data[9]);

            let TurbidezTratada = this.formatDados(data[10]);
            let TurbidezBruta = this.formatDados(data[11]);
            let CorBruta = this.formatDados(data[12]);

            let TurbidezFiltrada1 = this.formatDados(data[13]);
            let TurbidezFiltrada2 = this.formatDados(data[14]);
            let TurbidezFiltrada3 = this.formatDados(data[15]);
            let TurbidezFiltrada4 = this.formatDados(data[16]);
            let CorFiltrada1 = this.formatDados(data[17]);
            let CorFiltrada2 = this.formatDados(data[18]);
            let CorFiltrada3 = this.formatDados(data[19]);
            let CorFiltrada4 = this.formatDados(data[20]);
            
            let phGraph = this.formatDados(data[21]);
            let tempGraph = this.formatDados(data[22]);

            let CorTratada1 = data[23] ? this.formatDados(data[23]) : [{id: 'Cor tratada 1', data: []}];
            let TurbidezTratada1 = data[24] ? this.formatDados(data[24]) : [{id: 'Turbidez tratada 1', data: []}];
            
            let CorTratada2 = data[25] ? this.formatDados(data[25]) : [{id: 'Cor tratada 2', data: []}];
            let TurbidezTratada2 = data[26] ? this.formatDados(data[26]) : [{id: 'Turbidez tratada 2', data: []}];

            let cloro1 = data[27] ? this.formatDados(data[27]) : [{id: data[0][26], data: []}];
            let cloro2 = data[28] ? this.formatDados(data[28]) : [{id: data[0][27], data: []}];

            let sensorTable = await this.formatTableAnalysis(data[31]);
            let sensorGraph1 = this.formatDados(data[29]);
            let sensorGraph2 = this.formatDados(data[30]);

            let analysis = {
                AL1 :{
                    table: AL1,
                    graphs: [Fluoreto],
                },
                AL2 :{
                    table: AL2,
                    graphs: 
                        cloro1[0].data.length > 0 || 
                        cloro2[0].data.length > 0 ? [cloro1, cloro2] : [Cloro],
                },
                AL3 :{
                    table: AL3,
                    graphs: 
                    CorTratada1[0].data.length > 0 || CorTratada2[0].data.length > 0 || 
                    TurbidezTratada1[0].data.length > 0 || TurbidezTratada2[0].data.length > 0 ?
                        [CorTratada1, CorTratada2, TurbidezTratada1, TurbidezTratada2] :
                        [CorTratada, TurbidezTratada]
                },
                AL4 :{
                    table: AL4,
                    graphs: [CorBruta, TurbidezBruta],
                },
                AL5:{
                    table: AL5,
                    graphs: [TurbidezFiltrada1, TurbidezFiltrada2, TurbidezFiltrada3, TurbidezFiltrada4,
                        CorFiltrada1, CorFiltrada2, CorFiltrada3, CorFiltrada4],
                },
                ph:{
                    table: ph,
                    graphs: [phGraph, tempGraph],
                },
                sensor:{
                    table: sensorTable,
                    graphs: [sensorGraph1, sensorGraph2],
                }
            }
            store.dispatch(ChangeAnalysisData(analysis));
            store.dispatch(changeHistoricPagination(null));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricListData({
                AL1 :{table: [], graphs: [],},
                AL2 :{table: [], graphs: [],},
                AL3 :{table: [], graphs: [],},
                AL4 :{table: [], graphs: [],},
                AL5 :{table: [], graphs: [],},
                ph : {table: [], graphs: [],},
            }));
        }
    }

    // Pega os dados de analises
    async getOperationData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsOperations(id, datainicio, datafim, page);
            this.formatTableOperation(data);
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(ChangeListOperationMode([]));
            return [];
        }
    }

    // Pega os dados Detalhados
    async getAllData(id, datainicio, datafim, page){
        try {
            let data = await this.Requests.getmappingsAll(id, datainicio, datafim, page);
            this.formatTableAll(data[1]);
            store.dispatch(changeHistoricPagination(data[0]));
            return data;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            store.dispatch(changeHistoricPagination(null));
            store.dispatch(ChangeAllData({
                data: [],
                titles: [],
            }));
            return [];
        }
    }

    // Gera os dados para os gráficos
    async generateGraphData(data){
        let keys = data[0];
        let Graphdata = data.map((graphs, index) => {
            if(index !== 0 && index < data.length){
                if(graphs[0][1] === "informações" && graphs.length > 2){
                    return undefined;
                }else if(graphs.length > 2){
                    return{
                        [keys[index-1]] : this.formatDados(graphs)
                    };
                }else{
                    return undefined;
                }
            }else{
                return undefined;
            }
        })
        Graphdata = Graphdata.filter(dado => dado !== undefined);
        let priority = this.priorityItens.filter(item => 
            Graphdata.some(obj => Object.keys(obj)[0].toLowerCase().includes(item.toLowerCase()))
        );
        priority = new Map(priority.map((item, index) => [item, index]));
        Graphdata.sort((a, b) => {
            const aKey = Object.keys(a)[0];
            const bKey = Object.keys(b)[0];
            const getPriority = (key) => {
                for (let [priorityKey, priorityValue] of priority) {
                    if (key.toLowerCase().includes(priorityKey.toLowerCase())) {
                        return priorityValue;
                    }
                }
                return Infinity; 
            };
            const aPriority = getPriority(aKey);
            const bPriority = getPriority(bKey);
            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }        
            // Ordem alfabética como critério secundário
            return aKey.localeCompare(bKey);
        });
        store.dispatch(changeHistoricGraphData(Graphdata));
    }

    // Formatar os dados da tabela detalhada
    formatTableOperation(dataTable){
        if(dataTable.length > 0){
            let Operations = []
            dataTable.map((item, index) => {
                let title = item[0]
                item.shift();
                Operations[index] = {
                    title: title,
                    data: item

                }
                return item;
            });
            store.dispatch(ChangeListOperationMode(Operations));
        }else{
            store.dispatch(ChangeListOperationMode([]));
        }
    }

    // Formatar os dados da tabela detalhada
    formatTableAll(dataTable){
        if(dataTable.length > 0){
            let titles = []
            let TableData = dataTable.map(item => {
                titles = [...new Set([...titles, ...Object.keys(item)])]
                return {
                    'Values': item,
                }
            });
            let priority = this.priorityItens.filter(item => 
                titles.some(title => title.toLowerCase().includes(item.toLowerCase()))
            );
            priority = new Map(priority.map((item, index) => [item, index]));
            titles.sort((a, b) => {
                const getPriority = (title) => {
                    for (let [priorityKey, priorityValue] of priority) {
                        if (title.toLowerCase().includes(priorityKey.toLowerCase())) {
                            return priorityValue;
                        }
                    }
                    return Infinity;
                };
                const aPriority = getPriority(a);
                const bPriority = getPriority(b);
            
                return aPriority - bPriority || a.localeCompare(b);
            });
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            store.dispatch(ChangeAllData(TableData));
        }else{
            store.dispatch(ChangeAllData({
                data: [],
                titles: [],
            }))
        }
    }

    // Formatar os dados da tabela de analises
    formatTableAnalysis(dataTable){
        if(dataTable.length > 1){
            let titles = [];
            let TableData = dataTable.map((item, index) => {
                if(index > 0){
                    titles = [...new Set([...titles, ...Object.keys(item[0])])]
                    return{
                        'Values': item[0],
                        'Alarms': item[1],
                    }
                }else{
                    return undefined;
                }
            });
            TableData = TableData.filter(dado => dado !== undefined);
            titles.sort();
            try {
                titles.unshift(titles.splice(titles.indexOf('pH'), 1)[0]);
                titles.push(titles.splice(titles.indexOf('Manutenção'), 1)[0]);
            } catch (error) {
                console.log(error)
            }
            titles.unshift(titles.splice(titles.indexOf('Horário'), 1)[0]);
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            return TableData
        }else{
            return{
                data: [],
                titles: [],
            }
        }
    }

    // Formatar os dados da tabela geral
    formatTable(dataTable){
        if(dataTable.length > 0){
            let titles = [];
            let TableData = dataTable.map(item => {
                titles = [...new Set([...titles, ...Object.keys(item[0])])]
                return{
                    'Values': item[0],
                    'Alarms': item[1],
                }
            });
            let priority = this.priorityItens.filter(item => 
                titles.some(title => title.toLowerCase().includes(item.toLowerCase()))
            );
            priority = new Map(priority.map((item, index) => [item, index]));
            titles.sort((a, b) => {
                const getPriority = (title) => {
                    for (let [priorityKey, priorityValue] of priority) {
                        if (title.toLowerCase().includes(priorityKey.toLowerCase())) {
                            return priorityValue;
                        }
                    }
                    return Infinity;
                };
            
                const aPriority = getPriority(a);
                const bPriority = getPriority(b);
            
                return aPriority - bPriority || a.localeCompare(b);
            });
            // Caso tenha que ordenar pelo horário
            // TableData.sort((a, b) => {
            //     a.Values['Horário'] = new Date(a.Values['Horário'])
            //     b.Values['Horário'] = new Date(b.Values['Horário'])
            //     return a.Values['Horário'] - b.Values['Horário']
            // })
            TableData = {
                data: TableData,
                titles: titles,
            }
            store.dispatch(changeHistoricListData(TableData));
        }else{
            store.dispatch(changeHistoricListData({
                data: [],
                titles: [],
            }))
        }
    }

    // Formata os dados para os gráficos
    formatDados(dado){
        let dadoFormatado = [];
        let name;
        dadoFormatado = dado.map((info, index) => {
            if(index === 0 ){
                name = info[1]
                return undefined
            }else{
                if (dado.length > 5000) {
                    const anterior = dado[index - 1]?.[1];
                    const proximo = dado[index + 1]?.[1];

                    if (info[1] === anterior && info[1] === proximo) {
                        return undefined;
                    }
                }
                let value = isNaN(parseFloat(info[1])) ? info[1] : parseFloat(info[1]);
                return{
                    y: value,
                    x: new Date(info[0]),
                }
            }
        })
        dadoFormatado = dadoFormatado.filter(novodado => (novodado !== undefined && novodado.y !== undefined));
        return [{
            id: name,
            data: dadoFormatado,
            color: '#4361EE',
        }];
    }

    // Busca o arquivo na api
    async getExcel(id, datainicio, datafim, analysisMode, readingMode, methodOld, extension){
        store.dispatch(changeModal(''));
        try {
            let data1 = this.formatarDataParaYMDHMS(datainicio);
            let data2 = this.formatarDataParaYMDHMS(datafim);
            toast(i18n.t('message.historic-services.get-excel'), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            const excel = await this.Requests.getExcel(id, data1, data2, analysisMode, readingMode, methodOld, extension);
            if (excel?.data?.type === 'application/json') {
                    const text = await excel.data.text();
                    const json = JSON.parse(text);

                    toast(json.message, {
                        position: "top-center",
                        type: 'info',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                } else {
                    let equipamentName = this.equipamentosList.find(equipamento => equipamento.id === id).nome;
                    await this.createFile(excel.data, datainicio, datafim, equipamentName, analysisMode, extension);
                }
            
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }          
    }

    // Formatar a data
    formatarDataParaYMDHMS(time) {
        let data = new Date(time);
        const year = data.getFullYear();
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        const seconds = String(data.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    // Formatar a data
    formatarDataParaDMHM(time) {
        let data = new Date(time);
        const month = String(data.getMonth() + 1).padStart(2, '0');
        const day = String(data.getDate()).padStart(2, '0');
        const hours = String(data.getHours()).padStart(2, '0');
        const minutes = String(data.getMinutes()).padStart(2, '0');
        
        return `${day}-${month} ${hours}h${minutes}m`;
    }

    // Criar o arquivo para download
    async createFile (data, data1, data2, equipamentName, analysisMode, fileFormat){
        const url = window.URL.createObjectURL(data);
        let name = this.formatarDataParaDMHM(data1) + ' até ' +  this.formatarDataParaDMHM(data2);
      
        const link = document.createElement('a');
        link.href = url;
        link.download =  analysisMode ? `${equipamentName + ' ' + name +' Análises'}.${fileFormat}` : `${equipamentName + ' ' + name}.${fileFormat}`;
        link.click();
      
        // Liberar o URL do Blob após o download
        window.URL.revokeObjectURL(url);
    }

    // Pega os dados gerais todos equipamentos
    async getAllGraphData(Ids, datainicio, datafim){
        let tempData = store.getState().HistoricReducer.onlyGraphsData;
        let colors = this.equipamentsColors;
        try {
            let FilterIds = Ids.filter(id => id !== undefined && id !== null && id !== '');
            let allGraphs = await Promise.all(FilterIds.map(id => this.getOneGraphData(id, datainicio, datafim)));
            let groupedData = [];
            let AllData = [];
            allGraphs.map((sigle, index) => {
                sigle.map(data => {
                    // Verifica se a variavel ja existe e em qual lado foi inserida
                    tempData?.map(dado => 
                        Object.values(dado).map(variaveis => variaveis.map(variavel => {
                            if(variavel.id === data[Object.keys(data)[0]][0].id){
                                data[Object.keys(data)[0]][0].active = variavel.active
                                data[Object.keys(data)[0]][0].side = variavel.side
                            }
                            return variavel;
                        }))
                    )
                    data[Object.keys(data)[0]][0].color = colors[0];
                    colors = colors.slice(1);
                    AllData.push(data[Object.keys(data)[0]][0]);
                    return data;
                })
                return sigle;
            });
            groupedData.push({'Gráfico Geral' : AllData});
            groupedData[0]["Gráfico Geral"].sort((a, b) => {
                const keyA = a.id;
                const keyB = b.id;
                return keyA.localeCompare(keyB);
            });
            store.dispatch(changeOnlyGraphsData(groupedData));
            return groupedData;
        } catch (error) {
            store.dispatch(changeOnlyGraphsData([]));
            console.log(error)
        }
    }

    // Pega os dados gerais para 1 equipamento
    async getOneGraphData(id, datainicio, datafim){
        try {
            let data = await this.Requests.getmappingsGeneralGraph(id, datainicio, datafim);
            let Graphs = await this.generateOneGraphData(data, id);
            return Graphs;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Gera os dados para os gráficos
    async generateOneGraphData(data, id){
        let keys = data[0];
        let Graphdata = data.map((graphs, index) => {
            if(index !== 0 && index < data.length){
                if(graphs[0][1] === "informações" && graphs.length > 2){
                    return undefined;
                }else if(graphs.length > 2){
                    return{
                        [keys[index-1]] : this.formatDadosId(graphs, id)
                    };
                }else{
                    return undefined;
                }
            }else{
                return undefined;
            }
        })
        Graphdata = Graphdata.filter(dado => dado !== undefined)
        let priority = this.priorityItens.filter(item => 
            Graphdata.some(obj => Object.keys(obj)[0].toLowerCase().includes(item.toLowerCase()))
        );
        priority = new Map(priority.map((item, index) => [item, index]));
        Graphdata.sort((a, b) => {
            const aKey = Object.keys(a)[0];
            const bKey = Object.keys(b)[0];
            const getPriority = (key) => {
                for (let [priorityKey, priorityValue] of priority) {
                    if (key.toLowerCase().includes(priorityKey.toLowerCase())) {
                        return priorityValue;
                    }
                }
                return Infinity; 
            };
            const aPriority = getPriority(aKey);
            const bPriority = getPriority(bKey);
            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }        
            // Ordem alfabética como critério secundário
            return aKey.localeCompare(bKey);
        });
        return Graphdata;
    }

    // Formata os dados para os gráficos
    formatDadosId(dado, id){
        let dadoFormatado = [];
        let name;
        dadoFormatado = dado.map((info, index) => {
            if(index === 0 ){
                name = info[1];
                return undefined;
            }else{
                return{
                    y: info[1],
                    x: new Date(info[0]),
                }
            }
        })
        dadoFormatado = dadoFormatado.filter(novodado => (novodado !== undefined && novodado.y !== undefined));
        let equipamentName = this.equipamentosList.find(equipamento => equipamento.id === id)?.nome;
        return [{
            id: name + ' = ' + equipamentName,
            data: dadoFormatado,
            color: '#4361EE',
        }];
    }

    // Busca as cidades
    async getCities(){
        try {
            let cities = await this.Requests.RequestCities();
            cities.authorized_cities.forEach(obj => {
                obj.id = obj.code_ibge;
                obj.nome = obj.name;
                delete obj.name;
                delete obj.code_ibge;
            })
            let list = [{id: '', nome: i18n.t("select.city")}];
            list.push(...cities.authorized_cities);
            store.dispatch(changeHistoricCities(list));
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Filtra os equipamentos de acordo com a cidade selecionada
    filterEquipaments(city){
        store.dispatch(changeHistoricCity(city));
        if(city){
            store.dispatch(changeHistoricLoading(true));
            let newList = this.equipamentosList.filter(equipament=> parseInt(equipament.city_code) === parseInt(city) || equipament.city_code === undefined);
            store.dispatch(changeHistoricEquipamentList(newList));
        }else{
            store.dispatch(changeHistoricEquipamentList(this.equipamentosList));
        }
    }

    async changeCity(equipamento){
        try {
            let currentCity = this.equipamentosList.find(equip => equip.id === equipamento);
            let newList = this.equipamentosList.filter(equipament => parseInt(equipament.city_code) === parseInt(currentCity.city.code_ibge) || equipament.city_code === undefined);
            if(currentCity.city){
                store.dispatch(changeHistoricEquipamentList(newList));
                store.dispatch(changeHistoricCity(currentCity.city.code_ibge));
                return currentCity.city.code_ibge;
            }else{
                store.dispatch(changeHistoricCity(''));
                return '';
            }
        } catch (error) {
            setTimeout(() => {
                this.changeCity(equipamento);
            }, 2000);
            console.log(error)
        }
        return '';
    }
}